<script setup lang="ts">
withDefaults(defineProps<{
    label: string;
    // Monospace the value — used for routing/account numbers and other
    // code-like strings where character alignment helps readability.
    mono?: boolean;
}>(), {
    mono: false,
});
</script>

<template>
    <div class="csr">
        <p class="csr__label">{{ label }}</p>
        <p class="csr__value" :class="{ 'csr__value--mono': mono }"><slot /></p>
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.csr {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &__label {
        font-size: $text-portal-small;
        color: $portal-text-mid;
        margin: 0;
    }

    &__value {
        font-size: $text-portal-caption;
        font-weight: 700;
        color: $portal-text;
        margin: 0;
        line-height: 1.4;

        &--mono {
            font-family: ui-monospace, 'SF Mono', Menlo, monospace;
            letter-spacing: 0.02em;
        }
    }
}
</style>
